import { ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Settings } from '../app/app.settings';
import { loggerCallback } from './common';

export const testSettings: Settings = {
  baseUrl: 'https://ch-insecta-api-test.se.research.corteva.com',
  environment: 'test',
  isProd: false,
  appInsightsConnectionString:
    'InstrumentationKey=3762c963-bdda-4f09-935b-6962582e619e;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=027ccad1-88fa-4c47-9d81-635efed6e7a2',
  msal: {
    config: {
      auth: {
        clientId: 'c88c59ed-f825-41a6-b46f-04c7ca0c24fa',
        authority: 'https://login.microsoftonline.com/3e20ecb2-9cb0-4df1-ad7b-914e31dcdda4/',
        redirectUri: 'https://ch-insecta-test.se.research.corteva.com/after-login',
        postLogoutRedirectUri: 'https://ch-insecta-test.se.research.corteva.com/after-logout',
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false
        }
      }
    },
    guard: {
      interactionType: InteractionType.Redirect
    },
    interceptor: {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ['https://ch-insecta-api-test.se.research.corteva.com', ['api://c88c59ed-f825-41a6-b46f-04c7ca0c24fa/API.Call']]
      ])
    }
  }
};
